export const priceDisplay = (cents, subunitToUnit) => {
  // Determine if we should divide cents or if they're already the base unit.
  // For example, KRW and JPY have no decimals so subunit_to_unit will be 1.
  const ratio =
    subunitToUnit ||
    (typeof gon === 'object' ? gon.currency.subunit_to_unit : null) ||
    100;
  return cents / ratio;
};
